function cleanValue(value) {
  return String(value ?? "").trim().replace(/\s+/g, " ");
}

export function getWorkspaceDirectoryUrl(workspace) {
  const profile = workspace?.communityProfile ?? {};
  const tradeShow = workspace?.exhibitorPreview?.tradeShow ?? {};
  return (
    profile.exhibitorDirectoryUrl ||
    profile.eventUrl ||
    tradeShow.exhibitor_directory_url ||
    ""
  );
}

export function getDirectoryImportErrorMessage(error) {
  const detail = error?.response?.data?.detail;
  const code = typeof detail === "object" ? detail.code : "";
  if (code === "unsupported_provider") return "This exhibitor directory provider is not supported yet.";
  if (code === "public_directory_unavailable") return "The exhibitor directory is unavailable right now.";
  if (code === "no_exhibitor_directory_found") return "No exhibitor directory was found. Paste a supported directory URL.";
  if (code === "invalid_url") return "Enter a valid public exhibitor directory URL.";
  return typeof detail === "string" ? detail : "Unable to load exhibitors from this directory.";
}

export function filterExhibitorsBySearch(exhibitors, search) {
  const term = cleanValue(search).toLowerCase();
  if (!term) return exhibitors;
  return exhibitors.filter((exhibitor) =>
    [
      exhibitor.companyName,
      exhibitor.boothNumber,
      exhibitor.website,
      exhibitor.websiteDomain,
      exhibitor.industry,
      exhibitor.standardSectors,
      exhibitor.rawIndustry,
      exhibitor.employeeRange,
      exhibitor.estimatedEmployeeCount,
      exhibitor.sourcePlatform,
      exhibitor.matchStatus,
    ]
      .map((value) => cleanValue(value).toLowerCase())
      .some((value) => value.includes(term))
  );
}
